module.exports = __webpack_public_path__ + "media/src/assets/welcome_header_report_screen-0b33cfae03402f1d2d38553f595c2794.png";